export const MAX_CLIENT_POS_PER_ORDER = 20;
export const MAX_CLIENT_PO_FILE_BYTES = 5 * 1024 * 1024;
export const CLIENT_PO_UPLOAD_CONTAINER = "client-po";

export interface ClientPOActor {
  id: number;
  name: string;
}

/** One client PO on an order (`/v1/orders/client-po`). Migrated POs may have null number / url / creator. */
export interface OrderClientPO {
  id: number;
  order_id: number;
  po_number: string | null;
  po_url: string | null;
  created_by: ClientPOActor | null;
  updated_by: ClientPOActor | null;
  platform: string | null;
  created_at: string;
  updated_at: string;
}

export interface UpdateClientPORequest {
  po_number?: string;
  po_url?: string;
}

export type RemoveClientPOsRequest = { po_ids: number[] } | { all: true };

export interface RemoveClientPOsResult {
  removed_ids: number[];
  client_pos: OrderClientPO[];
}

/**
 * Client PO label as printed on invoices / PI: the first PO number plus how many more the order
 * has, e.g. "190293 (+1)". Falls back to the legacy single PO number when the list is not loaded.
 */
export const formatClientPOLabel = (
  clientPOs: OrderClientPO[] | undefined,
  legacyPONumber?: string | null,
): string => {
  const numbers = (
    clientPOs ? clientPOs.map((po) => po.po_number) : [legacyPONumber]
  )
    .map((poNumber) => poNumber?.trim() ?? "")
    .filter((poNumber) => poNumber !== "");
  if (numbers.length === 0) return "";
  const extra = numbers.length - 1;
  return extra > 0 ? `${numbers[0]} (+${extra})` : numbers[0];
};

/** Returns an error message for an invalid client PO file, or "" when the file is fine. */
export const validateClientPOFile = (file: File | null): string => {
  if (!file) return "PO document is required";
  if (file.type !== "application/pdf") return "Only PDF files are allowed";
  if (file.size > MAX_CLIENT_PO_FILE_BYTES) {
    return "File size must be less than 5MB";
  }
  return "";
};
